import apiClient from '../api/apiClient';

// =====================================================
// TYPES
// =====================================================

export interface Announcement {
  id: string;
  title: string;
  slug: string;
  content_html: string;
  content_json: any;
  excerpt: string;
  cover_image_url: string;
  author_id: string;
  status: 'draft' | 'published' | 'archived';
  target_audience: 'all' | 'admin' | 'beta' | 'subscriber';
  published_at: string;
  created_at: string;
  updated_at: string;
  is_read?: boolean;
  author_name?: string;
}

export interface AnnouncementFormData {
  title: string;
  content_html: string;
  content_json: any;
  excerpt?: string;
  cover_image_url?: string;
  status: 'draft' | 'published' | 'archived';
  target_audience: 'all' | 'admin' | 'beta' | 'subscriber';
}

// =====================================================
// USER-ENDPUNKTE
// =====================================================

export const getAnnouncements = async (params?: {
  limit?: number;
  offset?: number;
}): Promise<{ announcements: Announcement[]; pagination: any }> => {
  const response = await apiClient.get('/announcements', { params });
  return response.data;
};

export const getUnreadCount = async (): Promise<{ count: number }> => {
  const response = await apiClient.get('/announcements/unread-count');
  return response.data;
};

export const getAnnouncementBySlug = async (slug: string): Promise<Announcement> => {
  const response = await apiClient.get(`/announcements/${slug}`);
  return response.data.announcement;
};

export const markAsRead = async (id: string): Promise<{ success: boolean }> => {
  const response = await apiClient.post(`/announcements/${id}/read`);
  return response.data;
};

export const markAllAnnouncementsAsRead = async (): Promise<{ success: boolean; marked: number }> => {
  const response = await apiClient.post('/announcements/mark-all-read');
  return response.data;
};

// =====================================================
// ADMIN-ENDPUNKTE
// =====================================================

export const getAllAnnouncements = async (): Promise<{ announcements: Announcement[] }> => {
  const response = await apiClient.get('/admin/announcements');
  return response.data;
};

export const createAnnouncement = async (data: AnnouncementFormData): Promise<Announcement> => {
  const response = await apiClient.post('/admin/announcements', data);
  return response.data.announcement;
};

export const updateAnnouncement = async (id: string, data: Partial<AnnouncementFormData>): Promise<Announcement> => {
  const response = await apiClient.put(`/admin/announcements/${id}`, data);
  return response.data.announcement;
};

export const deleteAnnouncement = async (id: string): Promise<{ success: boolean }> => {
  const response = await apiClient.delete(`/admin/announcements/${id}`);
  return response.data;
};
